import type { WrittenPage } from '../../sections'

/**
 * Technology ROI Calculator sayfasının Türkçesi, 30.08.2026.
 *
 * Yalnızca aracın etrafındaki çerçeve; aracın kendi metinleri
 * `content/tools/roi-calculator.tr.ts` içinde. Bölüm sırası, iddialar ve
 * rakamlar İngilizcesiyle birebir aynı — değişen yalnızca nasıl söylendiği.
 *
 * Ürün adı ve yerleşik terimler İngilizce kalıyor: "Technology ROI Calculator",
 * Run / Grow / Transform, DAIMI. `route` burada tanımlanmaz; adres İngilizce
 * dosyada bir kez tanımlı.
 *
 * İngilizce sayfadaki fiyat `check:` notu orada duruyor ve burada tekrar
 * edilmiyor — bir not iki kez sorulmaz.
 */
export const toolsRoi: WrittenPage = {
  navLabel: 'Technology ROI Calculator',
  title: 'Technology ROI Calculator',
  description:
    'Sektörünüzün IT harcaması, cironuz ve hedefleriniz; gerçek değer vakalarıyla kalibre edilmiş bir modelle buluşuyor. Teknoloji bütçenizin bir yılda getirebileceği değer: somut, soyut ve beklemenin maliyeti.',
  sections: [
    {
      kind: 'hero',
      // Büyük harfler CSS'e bırakılmadan yazıldı: `text-transform` belgenin
      // diline göre çalışır ve Türkçede `i` → `İ` olur; aksi halde bu İngilizce
      // ad /tr sayfasında "TECHNOLOGY ROİ CALCULATOR" diye çıkar.
      eyebrow: 'TECHNOLOGY ROI CALCULATOR',
      headline: 'DAIMI: Size sağladığımız getiriyi öğrenin',
      sub: 'Çoğu yönetim kurulu teknolojinin ne kadara mal olduğunu söyleyebilir, neredeyse hiçbiri ne getirdiğini söyleyemez. Dört girdi (ciro, ülke, sektör ve ne yapmaya çalıştığınız) size sayıyı üç parçada veriyor: ölçebildiğiniz, hissettiğiniz ve yerinde saymanın size neye mal olacağı.',
      ctas: [],
    },
    { kind: 'tool', tool: 'roi-calculator' },
    {
      kind: 'prose',
      heading: 'Rakamlar nereden geliyor',
      paragraphs: [
        'Sektörünüz iki şeyi belirliyor: sizin gibi şirketlerin cirolarının ne kadarını IT’ye ayırdığı ve bu bütçenin mevcudu çalıştırmak, büyütmek ve dönüştürmek arasında nasıl bölündüğü. Değeri yalnızca ikinci ve üçüncü parça üretir (Run yalnızca ışıkları açık tutar), bu yüzden model bütçenin tamamı üzerinden değil, Grow ve Transform üzerinden çalışır. Ülkeniz harcamayı kendi bölgesine göre düzeltir, hedefleriniz de çarpanı düzeltir; çünkü bir maliyet azaltma programıyla yeni gelir programı dolar başına aynı şeyi getirmez.',
        'Çarpanın kendisi ve somut değeri soyut değere ve önlenen riske çeviren oranlar gerçek bir vakayla kalibre edildi: 25 milyon $ IT bütçesinin %45’i Grow ve Transform olan, 1 milyar $ cirolu bir imalat şirketi; sonuç 4,18x toplam değer oranı. Bu tek bir vaka ve bunu açıkça söylüyoruz. Çıkan sonucu bir iş vakası gibi değil, tartışabileceğiniz bir aralık gibi okuyun. Raporun altındaki not da aynı şeyi söylüyor.',
      ],
    },
    {
      kind: 'prose',
      heading: 'Soyut fayda ve “yapmasaydık” senaryosu neden hesaba katılıyor',
      paragraphs: [
        'Çünkü bunları dışarıda bırakmak, teknoloji yatırımının olduğundan küçük görünmesinin yoludur. Kötü veriyle alınmış yanlış bir stratejik karar, birbirine karşı çalışan bir yönetim ekibi, geciken bir programa kaybedilen bir çeyrek: hiçbiri fayda hesabında görünmez, hepsinin bedeli ödenir. Beklemek için de aynısı geçerlidir: veri borcu, ayrılan insanlar, beklemeyen rakip. Bu model ikisini de fiyatlıyor; iyimserlikle değil, aynı vakadan çıkan oranlarla.',
        'Yapmayacağı şey, hangi programınızı fonlamanız gerektiğini söylemektir. Onun için gerçek portföyünüz ve savunabileceğiniz bir başlangıç noktası gerekir: DAIMI’nin ölçtüğü şey budur ve buradan çıkan her rakamın doğal devamı o görüşmedir.',
      ],
    },
  ],
}
